import { useLocation, useNavigate } from "react-router-dom";
import { Button, Result, Space } from "@app/ui";
import { AuthShell } from "../auth/AuthShell.js";
import { useLang } from "../i18n.js";
import { useSeo } from "../seo.js";

/**
 * Catch-all for URLs the router does not know. Rendered in place — never a
 * redirect to "/" — with a noindex head, so a crawler files the URL as "not
 * found" instead of as one more copy of the home page (a soft 404). The edge
 * adds the matching X-Robots-Tag for every non-home SPA response.
 */
const COPY = {
  tr: {
    title: "Sayfa bulunamadı",
    body: "Aradığınız adres taşınmış ya da hiç var olmamış olabilir.",
    home: "Ana sayfaya dön",
    blog: "Bloga git",
    blogHref: "/blog",
  },
  en: {
    title: "Page not found",
    body: "The address may have moved or never existed.",
    home: "Back to home",
    blog: "Go to the blog",
    blogHref: "/en/blog",
  },
} as const;

export function NotFoundPage() {
  const { lang } = useLang();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const c = COPY[lang];

  useSeo({ title: `${c.title} | IDPP.net`, description: c.body, path: pathname, lang, noindex: true });

  return (
    <AuthShell>
      <Result
        status="404"
        title={c.title}
        subTitle={c.body}
        extra={
          <Space>
            <Button variant="primary" onClick={() => navigate("/")}>
              {c.home}
            </Button>
            {/* The blog is server-rendered by the API, not an SPA route — full navigation. */}
            <Button onClick={() => window.location.assign(c.blogHref)}>{c.blog}</Button>
          </Space>
        }
      />
    </AuthShell>
  );
}
